import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2, AlertTriangle, Sparkles } from "lucide-react";

const fits = [
    "8 years Hospitality HR",
    "ADP Workforce Now",
    "California Labor Law",
    "Bilingual — English & Spanish",
    "Available in 2 weeks",
];

export const HiringBrief = () => (
    <motion.div
        initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}
        data-testid="ai-hiring-brief-card"
        className="rounded-2xl border border-border bg-card shadow-xl overflow-hidden"
    >
        <div className="flex items-center justify-between px-6 py-4 border-b border-border bg-muted/50">
            <div className="flex items-center gap-2 font-heading font-semibold text-foreground">
                <Sparkles size={16} className="text-emerald-500" /> AI Hiring Brief™
            </div>
            <span className="text-[10px] uppercase tracking-wider text-muted-foreground">AI Match™ · Requirements met: 5 of 6</span>
        </div>
        <div className="p-6 sm:p-8">
            <div className="flex items-center justify-between gap-4">
                <div>
                    <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground">Matched candidate</div>
                    <div className="mt-1 font-heading font-semibold text-xl text-foreground">Marcus Reid — HR Manager</div>
                </div>
            </div>
            <div className="mt-6">
                <div className="text-sm font-semibold text-foreground mb-3">Why this candidate fits</div>
                <ul className="space-y-2.5">
                    {fits.map((f, i) => (
                        <motion.li
                            key={f} initial={{ opacity: 0, x: -10 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: 0.15 + i * 0.08 }}
                            className="flex items-center gap-2.5 text-sm text-foreground"
                        >
                            <CheckCircle2 size={16} className="text-emerald-500 shrink-0" /> {f}
                        </motion.li>
                    ))}
                </ul>
            </div>
            <div className="mt-6 flex items-start gap-2.5 rounded-xl border border-amber-500/30 bg-amber-500/10 p-4">
                <AlertTriangle size={16} className="text-amber-600 dark:text-amber-400 shrink-0 mt-0.5" />
                <div>
                    <div className="text-sm font-semibold text-foreground">Potential Gap</div>
                    <div className="text-sm text-muted-foreground">No Workday experience — transferable from ADP within 2–4 weeks.</div>
                </div>
            </div>
        </div>
    </motion.div>
);

export default HiringBrief;
